export const path = {
    wallOfFameAndSpotlight: {
        list: "/wall-of-fame-and-spotlight",
        create: "/wall-of-fame-and-spotlight/create",
        detail: "/wall-of-fame-and-spotlight/:id"
    },
    settings: {
        manageRecognitionFor: "/settings/manage-recognition-for",
        generalSettings: "/settings/general-settings",
    },
    permissionDenied: '/permission-denied',
}